import {
    AUTHORIZE_MFP_FAIL,
    AUTHORIZE_MFP_SUCCESS,
    UPDATE_CALORIES_FLAME_PERCENT,
    UPDATE_CALORIES_VIEW_STATE
} from 'actions/ActionTypes';

export const FlamePercentage = {
    DEFAULT: '25',
    ALMOST_DONE: '80',
    DONE: '100'
};

export const ViewStates = {
    LOADING: 'loading',
    GENESIS: 'genesis',
    UNABLE_TO_CONNECT: 'unable_to_connect',
    DISCONNECTED: 'disconnected',
    INACTIVE: 'in-active',
    SUMMARY: 'summary',
    SYNC: 'sync',
    RESTART: 'restart'
};

const INITIAL_STATE = {
    mfpConnectionState: '',
    mfpConnecting: false,
    flamePercent: FlamePercentage.DEFAULT
};

const caloriesViewStateUpdate = (state, action) => {
    if (action.state === ViewStates.SYNC) {
        return {
            ...state,
            mfpConnecting: true
        };
    }
    return {
        ...state,
        mfpConnectionState: action.state
    };
};

const updateFLamePercentUpdate = (state, action) => {
    return {
        ...state,
        flamePercent: action.flamePercent
    };
};

const mfpFail = (state) => {
    return {
        ...state,
        mfpConnecting: false
    };
};

const mfpAuthorized = (state) => {
    return {
        ...state,
        mfpConnecting: false,
        mfpConnectionState: ViewStates.SUMMARY,
        flamePercent: FlamePercentage.DONE
    };
};

const handlers = {
    [UPDATE_CALORIES_VIEW_STATE]: caloriesViewStateUpdate,
    [UPDATE_CALORIES_FLAME_PERCENT]: updateFLamePercentUpdate,
    [AUTHORIZE_MFP_FAIL]: mfpFail,
    [AUTHORIZE_MFP_SUCCESS]: mfpAuthorized
};

// ======= Actions =======
export function updateCaloriesViewState(newState) {
    return {
        type: UPDATE_CALORIES_VIEW_STATE,
        state: newState
    };
}

export function setFlamePercent(flamePercent) {
    return {
        type: UPDATE_CALORIES_FLAME_PERCENT,
        flamePercent: flamePercent
    };
}

// ======= Selectors =======
export const getMFPConnectionState = (state) => {
    return state.dailyCalories.mfpConnectionState;
};

export const isMFPConnecting = (state) => {
    return state.dailyCalories.mfpConnecting;
};

export const getMFPFlamePercent = (state) => {
    return state.dailyCalories.flamePercent;
};

// ======= Default =======
export default function dailyCalories(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
